var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgCreditCard = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 40,
  height: 27,
  fill: "none",
  viewBox: "0 0 40 27"
}, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
  width: 40,
  height: 26.286,
  fill: "#EBEBEB",
  rx: 3
})), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#C4C4C4",
  d: "M0 4.571h40v5.714H0z"
})));
export { SvgCreditCard as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNDAiIGhlaWdodD0iMjciIHZpZXdCb3g9IjAgMCA0MCAyNyIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHJlY3Qgd2lkdGg9IjQwIiBoZWlnaHQ9IjI2LjI4NTciIHJ4PSIzIiBmaWxsPSIjRUJFQkVCIi8+CjxyZWN0IHk9IjQuNTcxMjkiIHdpZHRoPSI0MCIgaGVpZ2h0PSI1LjcxNDI5IiBmaWxsPSIjQzRDNEM0Ii8+Cjwvc3ZnPgo=";